export enum PaymentProcessorEnum {
  Stripe = 'stripe',
  PaypalSoap = 'paypal-soap',
  Dlocal = 'dlocal',
  MercadoPagoBR = 'mercadopago-br',
  MercadoPagoCO = 'mercadopago-co',
  MercadoPagoMX = 'mercadopago-mx',
  MercadoPagoAR = 'mercadopago-ar',
  MercadoPagoCL = 'mercadopago-cl',
  Razorpay = 'razorpay',
  Flutterwave = 'flutterwave',
  Mollie = 'mollie',
  Gocardless = 'gocardless',
  XenditID = 'xendit-id',
  XenditPH = 'xendit-ph',
  PaystackGH = 'paystack-gh',
  PaystackKE = 'paystack-ke',
  PaystackNG = 'paystack-ng',
  PaystackZA = 'paystack-za',
  PaystackEG = 'paystack-eg',
  PaystackCI = 'paystack-ci',
  CashOnDelivery = 'cash-on-delivery',
  PaypalRest = 'paypal-rest',
  SecureAndPay = 'secure-and-pay',
}
